import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import {
  addQualificationRequest,
  addQualificationSuccess,
  loadTradesRequest,
  qualificationSelected,
  setShowNewQualificationModal,
} from 'actions/admin/work-orders/details/qualifications';
import NewQualificationForm from './NewQualificationForm';
import {
  getQualifications,
  getTrades,
} from 'selectors/admin/work-orders/details/qualifications';
import { qualificationsApi } from 'services/api/qualifications-api';
import { QualificationTypeEnum } from 'domain/qualification-type-enum';

class NewQualificationModal extends Component {
  render() {
    return (
      <FormModal
        show={true}
        title="Add Qualification"
        onClose={this.handleClose}
      >
        <NewQualificationForm
          loadLabelOptions={this.handleLoadLabelOptions}
          trades={this.props.trades}
          onQualificationCreated={this.handleQualificationCreated}
          onQualificationSelected={this.handleQualificationSelected}
        />
      </FormModal>
    );
  }

  componentDidMount() {
    this.props.dispatch(loadTradesRequest());
  }

  handleClose = () => {
    this.props.dispatch(setShowNewQualificationModal(false));
  };

  handleLoadLabelOptions = (input, type, trade) => {
    return qualificationsApi
      .searchQualifications(QualificationTypeEnum.getById(type), trade, input)
      .then((response) => {
        if (response.ok) {
          return {
            ok: true,
            options: response.qualifications
              .filter((qualification) => {
                return (
                  this.props.qualifications.find(
                    (element) => element.id === qualification.id
                  ) === undefined
                );
              })
              .map((element) => {
                return {
                  value: element.id,
                  label: element.label,
                  qualification: element, // add object to use it if the user select an existing label
                };
              }),
          };
        } else {
          return {
            ok: false,
            errors: response.errors,
          };
        }
      });
  };

  handleQualificationCreated = (values) => {
    this.props.dispatch(addQualificationRequest(values));
  };

  handleQualificationSelected = (qualification) => {
    this.props.dispatch(addQualificationSuccess(qualification));
    // Mark added qualification as selected
    this.props.dispatch(qualificationSelected(qualification.id));
    this.props.dispatch(setShowNewQualificationModal(false)); // close modal
  };
}

export default connect((state) => {
  return {
    qualifications: getQualifications(state),
    trades: getTrades(state),
  };
})(NewQualificationModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/qualifications/NewQualificationModal.js